import MyAppointmentsStateService from './my_appointment_state_service';
import { MyAppointmentsService } from './my_appointments_service';

angular
  .module('capability-ng-appointments')
  .service('ngMyAppointmentsService', MyAppointmentsService)
  .service('ngMyAppointmentsStateService', MyAppointmentsStateService);

export * from './my_appointments_service';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/services/services_module.ts